import { render, staticRenderFns } from "./zhini-pagination.vue?vue&type=template&id=62a949da&scoped=true&"
import script from "./zhini-pagination.vue?vue&type=script&lang=js&"
export * from "./zhini-pagination.vue?vue&type=script&lang=js&"
import style0 from "./zhini-pagination.vue?vue&type=style&index=0&id=62a949da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a949da",
  null
  
)

export default component.exports